import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useFleetHeaderStats } from '../hooks/useFleetHeaderStats';

const problemClass = {
  critical: 'text-critical',
  warning: 'text-warning',
};

/**
 * Компактные плашки Оборудования в шапке: иконка + X / N. Цвет только у чисел —
 * шапка остаётся нейтральной, акценты живут в контенте страницы.
 * Видны с lg; клик → /equipment?type=…
 */
const HeaderFleetStrip = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { stats } = useFleetHeaderStats(true);

  return (
    <div
      className="hidden items-center gap-1.5 lg:flex"
      role="navigation"
      aria-label={t('equipment.title')}
    >
      {stats.map(({ type, icon, ok, problem, problemTone }) => (
        <button
          key={type}
          type="button"
          onClick={() => navigate(`/equipment?type=${type}`)}
          title={t(`equipment.typeSingular.${type}`)}
          className="group inline-flex h-9 items-center gap-2 rounded-xl bg-white/[0.04] px-3 transition hover:bg-white/[0.08] focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-400"
        >
          <span className="material-icons text-[18px] text-muted-400 transition group-hover:text-white">
            {icon}
          </span>
          <span className="flex items-baseline gap-1 font-display text-sm leading-none tabular-nums">
            <span className="text-positive">{ok}</span>
            <span className="text-muted-600">/</span>
            <span className={problemTone ? problemClass[problemTone] : 'text-muted-500'}>{problem}</span>
          </span>
        </button>
      ))}
    </div>
  );
};

export default HeaderFleetStrip;
